var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mediaComponent)?_c(_vm.blockTemplate,{tag:"component",attrs:{"id":_vm.details.slug,"title":_vm.title,"subtitle":_vm.subtitle,"description":_vm.description,"image-url":_vm.imgUrl,"button-component":_vm.buttonComponent}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }